import idx from 'idx';
import * as React from 'react';
import { sortBy } from 'lodash';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import ContentLoader from 'react-content-loader';
import DeliveryModalSection from './DeliveryModalSection';
import Dialog from 'components/Dialog';
import EventTracking from 'lib/EventTracking';
import TitleHeader from 'components/TitleHeader';
import SocialMediaDeliveryModalSectionContainer from './DeliveryModalSection/SocialMediaDeliveryModalSectionContainer';
import SocialMediaDeliveryModalSection from './DeliveryModalSection/SocialMediaDeliveryModalSection';
import TranslationDeliveryModalSection from './TranslationDeliveryModalSection';
import type { fullDeliverySummary } from 'chat/fragments/__generated__/fullDeliverySummary';

import type {
  DeliverySummariesFromStream_me_tempStreamItem_MessageItem_reactionSummary,
  DeliverySummariesFromStream_me_tempStreamItem_MessageItem_sender,
} from 'chat/queries/__generated__/DeliverySummariesFromStream';
import type {
  fullPreciseSummaryEntry_users,
  fullPreciseSummaryEntry,
} from 'chat/fragments/__generated__/fullPreciseSummaryEntry';

import { MessageTranslationSummary_api_messageTranslationSummary_summary as TranslationSummary } from './__generated__/MessageTranslationSummary';
import ReactionsSection from './ReactionsSection';
import CurrentUser from 'auth/CurrentUser';
import LoadingIndicator from 'components/LoadingIndicator';
import moment from 'moment-timezone';

import './DeliveryModal.scss';

const EVENT_KEYS = {
  SUMMARY_VIEW: 'delivery_summary.view',
  NOT_YET_LOADED_VIEW: 'delivery_summary.not_yet_loaded.view',
  READ_USER_UNFOLD: 'delivery_summary.precise_summary.read_users.click',
  ERRORED_USER_UNFOLD: 'delivery_summary.precise_summary.errored_users.click',
  UNREACHABLE_USER_UNFOLD: 'delivery_summary.precise_summary.unreachable_users.click',
  DELIVERED_USER_UNFOLD: 'delivery_summary.precise_summary.delivered_users.click',
  ERRORED_USER_MAILTO: 'delivery_summary.estimated_summary.errored_users.contact_support.click',
};

export type Props = {
  loading: boolean;
  onRequestHide: Function;
  messageUuid: string;
  sentAt?: string;
  sender?: DeliverySummariesFromStream_me_tempStreamItem_MessageItem_sender;
  messageReadSummaries?: fullDeliverySummary | null;
  reactionSummary?: DeliverySummariesFromStream_me_tempStreamItem_MessageItem_reactionSummary | null;
  targetTitle?: string;
  targetDescription?: string;
  onRefetch?: (() => void) | null;
  onRequestDeliveryFailures?: (() => void) | null;
  onRequestDeliveryUnreachables?: (() => void) | null;
  translationSummary: TranslationSummary | null;
  translationSummaryLoading: boolean;
};

// prettier-ignore
const Ghost = () => (
  <ContentLoader height={500} speed={1}>
    <rect id="svg_26" height="20.00002" width="148.38723" y="32.25794" x="130.99993" stroke="#fff" fill="#000" />
    <rect id="svg_27" height="12.25808" width="96.77428" y="63.87087" x="156.8064" stroke="#fff" fill="#000" />
    <rect id="svg_28" height="12" width="209.67761" y="127.09673" x="32" stroke="#fff" fill="#000" />
    <rect id="svg_29" height="10.32259" width="49.67747" y="104.51607" x="32" stroke="#fff" fill="#000" />
    <rect stroke="#fff" id="svg_30" height="1" width="339" y="156.77418" x="32" fill="#000" />
    <rect id="svg_31" height="15.48389" width="33.54842" y="114.1935" x="336.80657" stroke="#fff" fill="#000" />
    <ellipse ry="9.35485" rx="9.35485" id="svg_32" cy="121.61286" cx="320.35494" stroke="#fff" fill="#000" />
    <rect id="svg_33" height="12" width="209.67761" y="197.41938" x="32" stroke="#fff" fill="#000" />
    <rect id="svg_34" height="10.32259" width="49.67747" y="174.83871" x="32" stroke="#fff" fill="#000" />
    <rect stroke="#fff" id="svg_35" height="1" width="339" y="227.09683" x="32" fill="#000" />
    <rect id="svg_36" height="15.48389" width="33.54842" y="184.51614" x="336.80657" stroke="#fff" fill="#000" />
    <ellipse ry="9.35485" rx="9.35485" id="svg_37" cy="191.9355" cx="320.35494" stroke="#fff" fill="#000" />
    <rect id="svg_38" height="12" width="209.67761" y="269.67751" x="32" stroke="#fff" fill="#000" />
    <rect id="svg_39" height="10.32259" width="49.67747" y="247.09684" x="32" stroke="#fff" fill="#000" />
    <rect stroke="#fff" id="svg_40" height="1" width="339" y="299.35495" x="32" fill="#000" />
    <rect id="svg_41" height="15.48389" width="33.54842" y="256.77427" x="336.80657" stroke="#fff" fill="#000" />
    <ellipse ry="9.35485" rx="9.35485" id="svg_42" cy="264.19363" cx="320.35494" stroke="#fff" fill="#000" />
  </ContentLoader>
);

export class DeliveryModal extends React.Component<Props, {}> {
  componentDidUpdate(prevProps: Props) {
    if (!prevProps.messageReadSummaries && this.props.messageReadSummaries) {
      EventTracking.trackKey(EVENT_KEYS.SUMMARY_VIEW);
    } else if (prevProps.loading && !this.props.loading && !this.props.messageReadSummaries) {
      EventTracking.trackKey(EVENT_KEYS.NOT_YET_LOADED_VIEW);
    }
  }

  computePercentageOfRecipients(count: number): number {
    return Math.floor((count / this.getRecipientCount()) * 100);
  }

  getRecipientCount(): number {
    // @ts-expect-error ts-migrate(2533) FIXME: Object is possibly 'null' or 'undefined'.
    return idx(this.props, (_) => _.messageReadSummaries.recipientCount) || 0;
  }

  isEstimate(summary: any): boolean {
    return summary.__typename === 'EstimatedSummaryEntry';
  }

  isPrecise(summary: any): boolean {
    return summary.__typename === 'PreciseSummaryEntry';
  }

  sortUsers(users: fullPreciseSummaryEntry_users[]) {
    users.sort((a, b) => a.uuid.localeCompare(b.uuid));
  }

  getReadSection() {
    const { messageReadSummaries } = this.props;
    if (!messageReadSummaries?.readEntry) {
      return null;
    }
    const summary = messageReadSummaries.readEntry;

    return (
      <DeliveryModalSection
        title="Read"
        status="read"
        users={
          this.isPrecise(summary)
            ? sortBy((summary as fullPreciseSummaryEntry).users, 'name')
            : undefined
        }
        count={summary.count}
        isEstimate={this.isEstimate(summary)}
        percent={this.computePercentageOfRecipients(summary.count)}
        onSectionUnfold={() => {
          EventTracking.trackKey(EVENT_KEYS.READ_USER_UNFOLD);
        }}
      />
    );
  }

  getUnreadSection() {
    const { messageReadSummaries } = this.props;
    if (!messageReadSummaries?.deliveredEntry) {
      return null;
    }
    const summary = messageReadSummaries.deliveredEntry;

    return (
      <DeliveryModalSection
        title="Delivered"
        status="delivered"
        users={
          this.isPrecise(summary)
            ? sortBy((summary as fullPreciseSummaryEntry).users, 'name')
            : undefined
        }
        count={summary.count}
        isEstimate={this.isEstimate(summary)}
        percent={this.computePercentageOfRecipients(summary.count)}
        onSectionUnfold={() => {
          EventTracking.trackKey(EVENT_KEYS.DELIVERED_USER_UNFOLD);
        }}
      />
    );
  }

  getErrorSection() {
    const { messageReadSummaries } = this.props;
    if (!messageReadSummaries?.failedEntry) {
      return null;
    }
    const summary = messageReadSummaries.failedEntry;

    return (
      <DeliveryModalSection
        title="Errors"
        status="delivery_error"
        users={
          this.isPrecise(summary)
            ? sortBy((summary as fullPreciseSummaryEntry).users, 'name')
            : undefined
        }
        count={summary.count}
        isEstimate={this.isEstimate(summary)}
        percent={this.computePercentageOfRecipients(summary.count)}
        onSectionUnfold={() => {
          EventTracking.trackKey(EVENT_KEYS.ERRORED_USER_UNFOLD);
        }}
        onRequestCSV={this.props.onRequestDeliveryFailures}
        downloadAvailable={messageReadSummaries.downloadAvailable}
        downloadAvailableUntil={messageReadSummaries.downloadAvailableUntil}
      />
    );
  }

  getReactionsSection() {
    if (
      this.props.reactionSummary &&
      CurrentUser.getUser().hasFeature('delivery_summary.web.jun-23')
    ) {
      return <ReactionsSection reactionSummary={this.props.reactionSummary} />;
    }
  }

  getUnreachableSection() {
    const { messageReadSummaries } = this.props;
    if (!messageReadSummaries?.unreachableEntry) {
      return null;
    }
    const summary = messageReadSummaries.unreachableEntry;

    if (summary.count < 1) {
      return null;
    }

    return (
      <DeliveryModalSection
        title="Unreachable"
        status="unreachable"
        users={
          this.isPrecise(summary)
            ? sortBy((summary as fullPreciseSummaryEntry).users, 'name')
            : undefined
        }
        count={summary.count}
        isEstimate={this.isEstimate(summary)}
        onSectionUnfold={() => {
          EventTracking.trackKey(EVENT_KEYS.UNREACHABLE_USER_UNFOLD);
        }}
        onRequestCSV={this.props.onRequestDeliveryUnreachables}
        downloadAvailable={messageReadSummaries.downloadAvailable}
        downloadAvailableUntil={messageReadSummaries.downloadAvailableUntil}
      />
    );
  }

  getIdentificationErrorSection() {
    const { messageReadSummaries } = this.props;
    if (!messageReadSummaries?.identificationErrorEntry) {
      return null;
    }
    const summary = messageReadSummaries.identificationErrorEntry;

    if (summary.count < 1) {
      return null;
    }

    return (
      <DeliveryModalSection
        title="Unidentified people"
        status="unidentifiable"
        users={
          this.isPrecise(summary)
            ? sortBy((summary as fullPreciseSummaryEntry).users, 'name')
            : undefined
        }
        unidentifiables={
          this.isPrecise(summary) ? (summary as fullPreciseSummaryEntry).unidentifiable : undefined
        }
        count={summary.count}
        isEstimate={false}
      />
    );
  }

  getSocialMediaSection() {
    const { messageUuid } = this.props;
    return (
      <SocialMediaDeliveryModalSectionContainer messageUuid={messageUuid}>
        {({ isFolded, postDeliverySummaries, toggleIsFolded }) => {
          return (
            <SocialMediaDeliveryModalSection
              isFolded={isFolded}
              postDeliverySummaries={postDeliverySummaries}
              toggleIsFolded={toggleIsFolded}
            />
          );
        }}
      </SocialMediaDeliveryModalSectionContainer>
    );
  }

  getTranslationSection() {
    const { translationSummary, translationSummaryLoading, messageReadSummaries } = this.props;

    if (translationSummaryLoading) {
      return <LoadingIndicator />;
    } else if (translationSummary) {
      /* This code is here to prevent the translation summary counts being inconsistent with the delivery summary count
       * By inferring/fudging the count of recipients with no preferred language,
       * we can make the sum of recipients by language match what the delivery summary says was the total number of message recipients
       * We do this by taking the total number of deliveries as reported in the delivery summary and subtracting
       *   1. the number of current target recipients with preferred languages that we translated to
       *   2. the number of current target recipients with preferred languages that we DID NOT provide a translation for
       * If that result is positive, we use it as an approximation of the number of recipients who have not set a preferred language
       * If the result is negative, we set a null value, which prevents the "No preferred language" section from being displayed */

      if (translationSummary.preferredLanguageRecipientsCount !== null) {
        const totalDeliveries = messageReadSummaries?.deliveredEntry?.count || 0;
        const deliveriesToRecipientsWithPreferredLanguage =
          (translationSummary?.preferredLanguageRecipientsCount || 0) +
          (translationSummary?.preferredLanguagesNotDelivered?.reduce(
            (count, summary) => (count += summary.recipientsCount),
            0
          ) || 0);

        const inferredNoPreferredLanguage =
          totalDeliveries - deliveriesToRecipientsWithPreferredLanguage;
        translationSummary.noPreferredLanguageRecipientsCount =
          inferredNoPreferredLanguage > 0 ? inferredNoPreferredLanguage : null;
      }

      return <TranslationDeliveryModalSection summary={translationSummary} />;
    }
  }

  render() {
    if (this.props.loading) {
      return (
        <Dialog
          size="small"
          className="DeliveryModal DeliveryModal-loading"
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          onRequestHide={this.props.onRequestHide}
        >
          <Ghost />
        </Dialog>
      );
    }

    if (!this.props.messageReadSummaries) {
      return (
        <Dialog
          size="small"
          className="DeliveryModal DeliveryModal-error"
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          onRequestHide={this.props.onRequestHide}
        >
          <BoxBody>
            <TitleHeader
              flush
              image={require('assets/images/admin/desk.svg')}
              imageSize="xxsmall"
              title="We’re creating your message summary."
              subtext="Please try again in a moment to see reads, deliveries, and errors for your message."
              action={
                this.props.onRefetch ? (
                  <Button onClick={this.props.onRefetch}>Try again</Button>
                ) : null
              }
            />
          </BoxBody>
        </Dialog>
      );
    }
    const hasDeliverySummaryEnhancements = CurrentUser.getUser().hasFeature(
      'delivery_summary.web.jun-23'
    );

    const by =
      hasDeliverySummaryEnhancements && this.props.sender?.actingUser
        ? ` by ${this.props.sender.actingUser?.displayName}`
        : '';

    const recipientCount = this.getRecipientCount();
    const to = ` to ${recipientCount} ${recipientCount === 1 ? 'person' : 'people'} `;

    let at = '';
    if (hasDeliverySummaryEnhancements && this.props.sentAt) {
      const date = moment.utc(this.props.sentAt);
      const firstPart = date.tz(moment.tz.guess()).format('h:mma ');
      const lastPart = date.tz(moment.tz.guess()).format(' on MMMM Do, YYYY');
      let formattedTimezone = date.tz(moment.tz.guess()).format('z');
      if (!Number.isNaN(parseInt(formattedTimezone))) {
        formattedTimezone = 'GMT' + formattedTimezone;
      }
      const formattedDate = `${firstPart}${formattedTimezone}${lastPart}`;
      at = ` at ${formattedDate}`;
    }

    let subtext = <>{`Sent${by}${to}${at}`}</>;

    return (
      <Dialog
        size="medium"
        title="Message summary"
        className="DeliveryModal"
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        onRequestHide={this.props.onRequestHide}
        subtext={subtext}
      >
        <BoxBody full>
          <div className="DeliveryModal-sections">
            {this.getUnreadSection()}
            {this.getReadSection()}
            {this.getErrorSection()}
            {this.getReactionsSection()}
            {this.getTranslationSection()}
            {this.getUnreachableSection()}
            {this.getIdentificationErrorSection()}
            {this.getSocialMediaSection()}
          </div>
        </BoxBody>
      </Dialog>
    );
  }
}

export default DeliveryModal;
